import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import { FormDeterminant } from "../../models/form-determinant";
import {Determinant} from "../../models/determinant";
import Helpers from "../../utils/helpers";

@Injectable()
export class FormDeterminantControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getById(id: string): Observable<FormDeterminant> {
    return this.http.get(this.baseUrl + "formdeterminant/" + id) as Observable<FormDeterminant>;
  }

  public getFormDeterminant(serviceId: string, key: string): Observable<FormDeterminant> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/formdeterminant/" + key) as Observable<FormDeterminant>;
  }

  public createFormDeterminant(serviceId: string, formDeterminant: FormDeterminant): Observable<FormDeterminant> {
    Helpers.trimRecursiveObj(formDeterminant);
    const body = JSON.stringify(formDeterminant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/formdeterminant", body) as Observable<FormDeterminant>;
  }

  public async modifyFormDeterminant(serviceId: string, formDeterminant: FormDeterminant): Promise<FormDeterminant> {
    if (formDeterminant.id) {
      return this.saveFormDeterminant(formDeterminant).toPromise();
    }
    const formDeterminantData = await this.getFormDeterminant(serviceId, formDeterminant.key).toPromise();
    if (formDeterminantData && formDeterminantData.id) {
      formDeterminant.id = formDeterminantData.id;
      return this.saveFormDeterminant(formDeterminant).toPromise();
    }
    return this.createFormDeterminant(serviceId, formDeterminant).toPromise();
  }

  // this is exceptional POST (update) with response which gives jsonLogic value
  public saveFormDeterminant(formDeterminant: FormDeterminant): Observable<FormDeterminant> {
    Helpers.trimRecursiveObj(formDeterminant);
    const body = JSON.stringify(formDeterminant);
    return this.http.post(this.baseUrl + "formdeterminant/" + formDeterminant.id, body) as Observable<FormDeterminant>;
  }

  public generateFormDeterminantOutOfRelationDeterminant(relationType: string, relationId: string): Observable<FormDeterminant> {
    return this.http.post(this.baseUrl + "behaviour/generate/" + relationType + "/" + relationId, {}) as Observable<FormDeterminant>;
  }

  public generateDeterminantForNewKeys(component: any, oldToNew: { [key: string]: string }): Observable<{ [key: string]: string }> {
    const body = {
      component,
      oldToNew,
    };
    return this.http.post(this.baseUrl + "behaviour/generate/newkeys", body) as Observable<{ [key: string]: string }>;
  }

}
